import { useEffect } from "react";
import { saveAs } from "file-saver";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import Base64ToBlob from "../../../../components/Formatters/Base64ToBlob";

const useDocumentoPS = () => {
  const { request: requestDocumento, data: dataDocumento } = useApiClient();

  const showDocumentoPs = (documentoPs, nomeArquivo, salvar) => {
    let byteArray = documentoPs;

    if (typeof byteArray === "string") {
      byteArray = Base64ToBlob(documentoPs);
    }

    if (nomeArquivo) {
      const tipoArquivo = nomeArquivo.split(".").pop();

      if (tipoArquivo !== "pdf" || salvar) {
        const file = new Blob([byteArray], { type: `application/${tipoArquivo}` });
        saveAs(file, nomeArquivo);
      } else {
        const file = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(file);
        window.open(url, "", "width=800,height=800");
      }
    } else {
      const file = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800");
    }
  };

  const buscaDocumento = (sqParteServico) => {
    const values = { sqParteServico };

    requestDocumento(apiRoutes.fiscalizacao.parteservico.downloadDocumentoPS, values);
  };

  useEffect(() => {
    if (dataDocumento) {
      showDocumentoPs(dataDocumento);
    }
  }, [dataDocumento]);

  return { buscaDocumento };
};

export default useDocumentoPS;
